import { Button, Checkbox, Col, DatePicker, Form, Input, Row, Select } from "antd"
import React, { useRef, useState } from "react"
import TextUtils from "../../../helpers/TextUtils"
import { SexList } from "../../../constants/bilet-constant"
import changepassIcon from '../../../assets/images/bilet/login/changepass_icon.png';
import { baseUrl } from "../../../constants/environment";
import APIClient from "../../../helpers/APIClient";
import { toast } from "react-toastify";
import { useHistory } from "react-router";

const List = (props: any) => {
    const router = useHistory()
    const [loading, setLoading] = useState<any>({})
    const [data, setData] = useState<any>({})
    const formRef = useRef<any>(null)
    const handleChangeInput = (event?: any) => {
        let { value, name } = event.target;
        if (value === " ") return;
        setData({
            ...data,
            [name]: value,
        });
    };
    const handleSubmit = async () => {
        await formRef?.current?.validateFields()
        if (data?.newpassword !== data?.re_newpassword) {
            toast.error("Mật khẩu mới và mật khẩu nhập lại không giống nhau!")
            return
        }
        const URL = `${baseUrl}/auth/me/changepass`
        const params = {
            password: data?.password,
            newpassword: data?.newpassword,
        }
        setLoading(true)
        let response: any = await APIClient.PUT(URL, params);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description);
        } else if (response.response !== undefined) {
            toast.success("Thay đổi mật khẩu thành công")
            router?.push("/account/logout")
        }
    }
    return (
        <Form
            ref={formRef}
            wrapperCol={{ flex: 1 }}
            layout="vertical"
            autoComplete="off"
            className="form_normal"
            fields={[
                { name: "password", value: data.password },
                { name: "newpassword", value: data.newpassword },
                { name: "re_newpassword", value: data.re_newpassword },
            ]}
        >
            <Row gutter={[50, 0]} align="middle">
                <Col md={12} xs={24}>
                    <Form.Item label="Mật khẩu cũ" name="password" rules={[{ required: true, message: "Mật khẩu cũ là bắt buộc" }]}>
                        <Input type="password" onChange={(e: any) => handleChangeInput(e)} value={data?.password} allowClear name="password" placeholder="Mật khẩu cũ" />
                    </Form.Item>
                    <Form.Item label="Mật khẩu mới" name="newpassword" rules={[{ required: true, message: "Mật khẩu mới là bắt buộc" }]}>
                        <Input type="password" onChange={(e: any) => handleChangeInput(e)} value={data?.newpassword} allowClear name="newpassword" placeholder="Mật khẩu mới" />
                    </Form.Item>
                    <Form.Item label="Nhập lại mật khẩu" name="re_newpassword" rules={[{ required: true, message: "Mật khẩu xác thực là bắt buộc" }]}>
                        <Input type="password" onChange={(e: any) => handleChangeInput(e)} value={data?.re_newpassword} allowClear name="re_newpassword" placeholder="Nhập lại mật khẩu" />
                    </Form.Item>
                    <div className="mt-4 d-flex align-items-center justify-content-end">
                        <Button className="bilet_button" onClick={handleSubmit}>Lưu</Button>
                    </div>
                </Col>
                <Col md={12} xs={0}>
                    <div className="chanpass_icon d-flex justify-content-center">
                        <img src={changepassIcon} alt="icon" />
                    </div>
                </Col>
            </Row>
        </Form>
    )
}
export default List